import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    position: 'relative',
    height: 675,
    marginBottom: 100,
    [media.s.down]: {
      height: 390,
    },
  },
  newsBg: {
    position: 'absolute',
  },
  newsInfo: {
    color: 'white',
    position: 'absolute',
    zIndex: 3,
    right: '10%',
    width: '40%',
    [media.s.down]: {
      width: '80%',
    },
  },
  slideInfo: {
    color: 'white',
    position: 'absolute',
    zIndex: 3,
    right: '10%',
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: '80%',
    [media.s.down]: {
      width: '80%',
    },
  },
  slideContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  signupContainer: {
    background: colors.sas.primary,
    width: '350px',
    color: 'white',
    padding: scale.m,
    borderRadius: scale.s,
    position: 'absolute',
    top: '5%',
    left: '10%',
    zIndex: 9,
    paddingTop: 300,
  },
  slideHeading: {
    fontSize: '1.75rem',
    whiteSpace: 'normal',
    lineHeight: '2.25rem',
    marginTop: scale.s,
    textAlign: 'right',
  },
  slideText: {
    fontSize: '1rem',
    whiteSpace: 'normal',
    lineHeight: '1.25rem',
    marginTop: scale.s,
    textAlign: 'right',
  },
  signupTitle: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: '2rem!important',
    marginTop: scale.s,
    textAlign: 'center',
  },
  signupText: {
    lineHeight: '1.7rem',
    fontSize: 16,
    textAlign: 'center',
  },
  joinInput: {
    border: 'none',
    borderRadius: '40px',
    outline: 'none',
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '10px',
    paddingRight: '10px',
    width: '100%',
    position: 'relative',
    height: '80%',
    color: 'black',
  },
  joinBox: {
    position: 'relative',
    height: 50,
  },
  joinButton: {
    position: 'absolute',
    width: '30%',
    right: 0,
    top: 0,
    color: colors.sas.primary,
    background: colors.sas.secondary,
    borderRadius: '20px',
    fontSize: '14px',
    paddingLeft: '15px',
    paddingRight: '10px',
    height: '80%',
    alignItems: 'center',
    display: 'flex',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  signupPicture: {
    position: 'absolute',
    left: 0,
    top: -50,
  },
  newsImage: {
    borderRadius: 10,
    width: '100%',
  },
  newsCategory: {
    color: '#63EFFF',
  },
  newsHeadline: {
    fontSize: '2rem',
    whiteSpace: 'normal',
    lineHeight: '2.25rem',
    marginTop: scale.s,
    textAlign: 'right',
  },
  newsMetaContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [media.s.down]: {
      flexDirection: 'column',
      alignItems: 'end',
    },
  },
  ctaButton: {
    padding: '10px 20px 10px 20px',
    boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
    fontSize: '1.5rem',
    backgroundColor: '#20FFC0',
    borderRadius: 50,
    color: '#651FFF',
    marginLeft: scale.m,
    '&:hover': {
      color: '#4100d2',
    },
  },
  newsButton: {
    padding: '10px 20px 10px 20px',
    border: `#FFF 1px solid`,
    borderRadius: 50,
    color: '#FFF',
    marginLeft: scale.m,
    '&:hover': {
      color: '#FFF',
    },
  },
  salesFlash: {
    backgroundColor: '#FFF',
    borderRadius: 50,
    boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
    color: '#263238',
    fontSize: '1.5rem',
    padding: '16px',
  },
});
